var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowsOssvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    height: 12,
    stroke: "none",
    viewBox: "0 0 12 12",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.249 5.2634v-4.418185l-5.24997656.657925v3.76026z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.99902 5.26342h5.99998v-5.26415242l-5.99998.75192542z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.99902 6.01538v4.51212l5.99998.7521v-5.26422z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.249 6.01538h-5.24997656v3.76013l5.24997656.65799z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsOssvg);
export default __webpack_public_path__ + "static/media/WindowsOSSVG.162f5de2.svg";
export { ForwardRef as ReactComponent };